import React, { useEffect, useState } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import useSwipe from "../../hooks/useSwipe"

const SwipeablePages = ({ children, urls }) => {
    const navigate = useNavigate()
    const location = useLocation()
    const [currentPageIndex, setCurrentPageIndex] = useState(0)

    useEffect(() => {
        const index = urls.indexOf(location.pathname)

        if (index !== -1) setCurrentPageIndex(index)
    }, [location])

    const swipeHandlers = useSwipe({
        onSwipedLeft: () => {
            const newPageIndex = Math.min(urls.length - 1, currentPageIndex + 1)
            if (newPageIndex !== currentPageIndex) navigate(urls[newPageIndex])
        },
        onSwipedRight: () => {
            const newPageIndex = Math.max(0, currentPageIndex - 1)
            if (newPageIndex !== currentPageIndex) navigate(urls[newPageIndex])
        },
    })

    return (
        <div className="w-full h-full" {...swipeHandlers}>
            {children}
        </div>
    )
}

export default SwipeablePages
